.item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding-right: var(--space-4);
  border-top: 1px solid var(--color-border);
}

.item:first-child {
  border-top: none;
}

.row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-1) var(--space-3);
  flex: 1;
  min-width: 0;
  padding: var(--space-3) var(--space-2) var(--space-3) var(--space-5);
  color: var(--color-text);
  text-decoration: none;
}

.link:hover .name {
  color: var(--color-accent-text);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.name {
  font-weight: var(--font-weight-bold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1) var(--space-2);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.aside {
  text-align: right;
  white-space: nowrap;
}

/* Phones: the time moves under the name, so the name keeps the full width. */
@media (width < 40rem) {
  .row {
    grid-template-columns: auto minmax(0, 1fr);
    padding-left: var(--space-4);
  }

  .aside {
    grid-column: 2;
    text-align: left;
  }
}
